import "./index.scss";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

const NameInput = ({ values, setValues }: { values: string[]; setValues: Function }) => {
  const { t } = useTranslation();
  return (
    <div className="Component_NameInput">
      <div className="input_wrapper">
        <Input
          className="h-[40px] w-[238px]! text-[16px] leading-[24px] font-normal"
          onChange={(e) => {
            setValues([e.target.value, values[1]]);
          }}
          value={values[0]}
          placeholder={t("First Name")}
        ></Input>
        <Input
          className="h-[40px] w-[238px]! text-[16px] leading-[24px] font-normal"
          onChange={(e) => {
            setValues([values[0], e.target.value]);
          }}
          value={values[1]}
          placeholder={t("Last Name")}
        ></Input>
      </div>
    </div>
  );
};

export default NameInput;
